import React,{useState} from "react";
import axios from "axios";
import { useQuery } from "react-query";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { ThreeDots } from "react-loader-spinner";
import { useSelector, useDispatch } from 'react-redux';
import { logout, reset } from "../../../features/auth/authSlice";
import { reset as invoiceReset } from "../../../features/invoice/invoiceSlice.js";
import { reset as headerReset } from "../../../features/headerText/headerTextSlice.js";
import { reset as appSettingsReset } from "../../../features/appSettings/appSettingsSlice.js";

const BankAccountVerification = ({ email,wiseBanks,isLoading,isError }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const emailExists = wiseBanks.some(
    (bank) => bank.details && bank.details.email === email
  );

  if (emailExists) {
   var verificationStatus = 'Yes';
  } else {
    var verificationStatus = 'No';
  }

  return (
    <>
      {isLoading ? (
        <ThreeDots
          height="18"
          width="20"
          radius="9"
          color="#6479f9"
          ariaLabel="three-dots-loading"
          wrapperStyle={{}}
          wrapperClassName=""
          visible={true}
        />
      ) : isError ? (
        // Handle error state here if needed
        <span>Error</span>
      ) : (
        <span>{verificationStatus}</span>
      )}
    </>
  );
};

export default BankAccountVerification;